import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-custom-contact-aging-dw",
  templateUrl: "./custom-contact-aging-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomContactAgingDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.CUSTOM_CONTACT_AGING_REPORT_DW;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID,
                           HideFilters.PROJECT_NAME2, HideFilters.CUSTOMER_NAME, HideFilters.ORGANIZATION_NAME];
}
